import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const FormButton = ({ title, loading }) => {
      return (
            <>
                  <Button type="submit">
                        {title}{' '}
                        {loading && (
                              <Spinner
                                    style={{
                                          height: '18px',
                                          width: '18px',
                                          marginLeft: '6px'
                                    }}
                                    animation="border"
                                    role="status"
                              >
                                    <span className="visually-hidden">
                                          Loading...
                                    </span>
                              </Spinner>
                        )}
                  </Button>
            </>
      );
};

export default FormButton;
